import { has, omit } from 'lodash';

import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';
import { hasActiveSession } from 'utils/session';

const RECEIVE_UNREAD_CONVERSATIONS = 'messengerNotifications/RECEIVE_UNREAD_CONVERSATIONS';
const MARK_CONVERSATION_AS_READ = 'messengerNotifications/MARK_CONVERSATION_AS_READ';

const initialState = {
  unreadChatsList: [],
  unreadChatsMap: {},
  unreadChatsCount: 0
};

function receiveUnreadConversations(data) {
  return {
    type: RECEIVE_UNREAD_CONVERSATIONS,
    payload: data
  };
}

export function markConversationAsRead(externalId) {
  return {
    type: MARK_CONVERSATION_AS_READ,
    payload: externalId
  };
}

export function fetchUnreadConversations(organizationId) {
  const url = `${API.END_POINTS.MESSENGER.getUnreadMessages()}?organization_id=${organizationId}`;

  return (dispatch) => {
    if (!hasActiveSession()) {
      return dispatch(receiveUnreadConversations({ ...initialState }));
    }

    return get(url)
      .then((response) => {
        const unreadChatsList = (response.data.data || []);
        const unreadChatsMap = {};
        unreadChatsList.forEach((chat) => {
          unreadChatsMap[chat.externalId] = chat;
        });

        const data = {
          unreadChatsList,
          unreadChatsMap,
          unreadChatsCount: unreadChatsList.length
        };

        dispatch(receiveUnreadConversations(data));
      })
      .catch((error) => {
        logError(error);
      });
  };
}

export default createReducer('messengerNotifications', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RECEIVE_UNREAD_CONVERSATIONS]: (state, { unreadChatsList, unreadChatsMap, unreadChatsCount }) => ({
    ...state,
    unreadChatsList,
    unreadChatsMap,
    unreadChatsCount
  }),
  [MARK_CONVERSATION_AS_READ]: (state, externalId) => {
    const conversationIsUnread = has(state.unreadChatsMap, externalId);
    return conversationIsUnread ? ({
      ...state,
      unreadChatsList: state.unreadChatsList.filter(chat => chat.externalId !== externalId),
      unreadChatsMap: omit(state.unreadChatsMap, externalId),
      unreadChatsCount: state.unreadChatsCount - 1
    }) : state;
  }
});
